import { Injectable } from '@angular/core';
import { ConfigService } from '@ngx-config/core';
import * as moment from 'moment/moment';
import 'shared/date.interface'
import { HttpParams } from '@angular/common/http';
import { Paging } from 'shared/entities/paging.entity';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  protected apiUrl: string;
  constructor(protected readonly config: ConfigService) {
    this.apiUrl = this.config.getSettings('Api.Url');
  }

  protected AjustarDataHora(key: any, value: any): any {
    if (typeof value === 'string' ) {
        if (moment(value, moment.ISO_8601).isValid() && value.length >=10) {
            return moment(value, moment.ISO_8601).toDate();
        }
    }
    return value;
  }

  protected MontarArrayPaginacaoOrdenacao(params : HttpParams, Paginacao: Paging) : HttpParams
    {
       
        if (Paginacao.PageIndex!=null)
        params = params.set("Pagina",Paginacao.PageIndex.toString());
        if (Paginacao.PageSize)
        params = params.set("NumeroRegistros",Paginacao.PageSize.toString());
        if (Paginacao.SortField != null && Paginacao.SortField.length > 0)
        Paginacao.SortField.forEach(texto=>{
            params =  params.append("SortFields",texto);
        });

        if (Paginacao.SortOrder != null && Paginacao.SortOrder.length > 0)
        Paginacao.SortOrder.forEach(texto=>{
            params = params.append("SortOrder",texto);
        });
        return params;

    }

    public base64ToBlob(b64Data, extensao = "", contentType = "", sliceSize = 512) {
      b64Data = b64Data.replace(/\s/g, ""); //IE compatibility...
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
  
        let byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays, { type: contentType?contentType: this.createFileType(extensao) });
    }
  
    public createFileType(e): string {
      let fileType: string = "";
      if (e == 'pdf' || e == 'csv') {
        fileType = `application/${e}`;
      }
      else if (e == 'jpeg' || e == 'jpg' || e == 'png') {
        fileType = `image/${e}`;
      }
      else if (e == 'txt') {
        fileType = 'text/plain';
      }
      else if (e == 'ppt' || e == 'pot' || e == 'pps' || e == 'ppa') {
        fileType = 'application/vnd.ms-powerpoint';
      }
      else if (e == 'pptx') {
        fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
      }
      else if (e == 'doc' || e == 'dot') {
        fileType = 'application/msword';
      }
      else if (e == 'docx') {
        fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      }
      else if (e == 'xls' || e == 'xlt' || e == 'xla') {
        fileType = 'application/vnd.ms-excel';
      }
      else if (e == 'xlsx') {
        fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      }
  
      return fileType;
    }
  
    public DownloadFile(arquivoBase64: string, nome:string, extensao: string, contentType:string="" ) {
  
      let blob = this.base64ToBlob(arquivoBase64, extensao);
     
      saveAs(blob, nome);
    }

}

